import { linksConstants } from "../../constants/linksConstants";

/* Hero Images */

// Financial Services
import financial_group_1_horizontal from "../assets/svg/Industry/FinancialGroup-1_horizontal.svg";
import financial_group_2_horizontal from "../assets/svg/Industry/FinancialGroup-2_horizontal.svg";
import financial_group_1_vertical from "../assets/svg/Industry/FinancialGroup-1_vertical.svg";
import financial_group_2_vertical from "../assets/svg/Industry/FinancialGroup-2_vertical.svg";

// Insurance
import insurance_group_1_horizontal from "../assets/svg/Industry/InsuranceGroup-1_horizontal.svg";
import insurance_group_2_horizontal from "../assets/svg/Industry/InsuranceGroup-2_horizontal.svg";
import insurance_group_3_horizontal from "../assets/svg/Industry/InsuranceGroup-3_horizontal.svg";
import insurance_group_1_vertical from "../assets/svg/Industry/InsuranceGroup-1_vertical.svg";
import insurance_group_2_vertical from "../assets/svg/Industry/InsuranceGroup-2_vertical.svg";
import insurance_group_3_vertical from "../assets/svg/Industry/InsuranceGroup-3_vertical.svg";

// Footer
import Anz from "../views/assets/logos/Anz.svg";
import StandardChartered from "../views/assets/logos/StandardChartered.svg";
import Clearco from "../views/assets/logos/Clearco.svg";
import Farmers from "../views/assets/logos/Farmers.svg";
import Openly from "../views/assets/logos/Openly.svg";

/* Data Providers Images */
import OpenCorporates from "../views/assets/logos/OpenCorporates.svg";
import Experian from "../views/assets/logos/Experian.svg";
import Equifax from "../views/assets/logos/Equifax_1.svg";
import Sayari from "../views/assets/logos/Sayari.svg";
import Seon from "../views/assets/logos/Seon_1.svg";
import Ekata from "../views/assets/logos/Ekata_1.svg";
import Nomino from "../views/assets/logos/Nomino.svg";
import Acxiom from "../views/assets/logos/Acxiom.svg";
import Attom from "../views//assets/logos/Attom.svg";
import HazardHub from "../views//assets/logos/HazardHub.svg";
import DataAxle from "../views//assets/logos/DataAxle.svg";
import Infutor from "../views//assets/logos/Infutor.svg";
import PeopleDataLabs from "../views/assets/logos/PeopleDataLabs.svg";

import Check from "../assets/card-check.svg";

const data = {
  hero: {
    financialServices: {
      title: "Optimize your external data spend with a single platform",
      description: "Rapidly deploy the right external data solutions for financial services.",
      images: {
        mainSection: [
          {
            id: 1,
            img: { desktop: financial_group_1_horizontal, mobile: financial_group_1_vertical },
            alt: "group of icons 1",
          },
          {
            id: 2,
            img: { desktop: financial_group_2_horizontal, mobile: financial_group_2_vertical },
            alt: "group of icons 2",
          },
        ],
        footerSection: [
          {
            id: 1,
            img: Anz,
            alt: "ANZ",
            width: "96",
            height: "31",
          },
          {
            id: 2,
            img: StandardChartered,
            alt: "Standart Chartered",
            width: "111",
            height: "45",
          },
          {
            id: 3,
            img: Clearco,
            alt: "Clearco",
            width: "119",
            height: "25",
          },
        ],
      },
    },
    insurance: {
      title: "Optimize your external data spend with a single platform",
      description: "Rapidly deploy the right external data solutions for insurance.",
      images: {
        mainSection: [
          {
            id: 1,
            img: { desktop: insurance_group_1_horizontal, mobile: insurance_group_1_vertical },
            alt: "group of icons 1",
          },
          {
            id: 2,
            img: { desktop: insurance_group_2_horizontal, mobile: insurance_group_2_vertical },
            alt: "group of icons 2",
          },
          {
            id: 3,
            img: { desktop: insurance_group_3_horizontal, mobile: insurance_group_3_vertical },
            alt: "group of icons 3",
          },
        ],
        footerSection: [
          {
            id: 1,
            img: Farmers,
            alt: "Farmers",
            width: "82",
            height: "44",
          },
          {
            id: 2,
            img: Openly,
            alt: "Openly",
            width: "71",
            height: "45",
          },
        ],
      },
    },
  },
  textSection: {
    financialServices: [
      {
        title: "Attract the right customers",
        text1: "Focus targeting on demographics aligned with your strategy",
        text2: "Confidently identify, enrich, and prioritize the right marketing leads",
        img: Check.src,
      },
      {
        title: "Frictionless onboarding and verification",
        text1: "Onboard customers seamlessly in seconds",
        text2: "Verify customers globally with a single platform",
        img: Check.src,
      },
      {
        title: "Maintain and retain customers",
        text1: "Customer 360 for cross-sell, up-sell & retention optimization",
        text2: "Regularly diligence your customer portfolio",
        img: Check.src,
      },
    ],
    insurance: [
      {
        title: "Expand customer lifetime value",
        text1: "Customer 360 for cross-sell, up-sell & retention optimization",
        text2: "Confidently identify, enrich, and prioritize the right marketing leads",
        img: Check.src,
      },
      {
        title: "Reduce application drop-off",
        text1: "Prefill auto, property and business details for rapid onboarding",
        text2: "Gather a more extensive set of data for underwriting",
        img: Check.src,
      },
      {
        title: "Optimise your claims processes",
        text1: "Verify and validate the identity of the claimant",
        text2: "Enrich customer contact details to improve contactability",
        img: Check.src,
      },
    ],
  },
  metrics: {
    financialServices: [
      { label: "12x", description: "Reduce fraud false positives by up to" },
      { label: "1", description: "Platform for all your use cases" },
      { label: "97%", description: "Accelerate customer onboarding by up to" },
    ],
    insurance: [
      {
        label: "32,000",
        description: "Additional high churn risk customers identified for a leading Insurer",
      },
      { label: "1", description: "Platform for all your use cases" },
      { label: "87%", description: "Of US customer profiles enriched for a global insurtech" },
    ],
  },
  recipes: {
    financialServices: [
      {
        title: "Business Firmographics for US KYB, Onboarding and Marketing",
        description: "Use this recipe to retrieve US firmographics ...",
        url: "/app/recipe/2/business-firmographics-for-us-kyb-onboarding-and-marketing",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
      {
        title: "Business Registration and UBO for US KYB",
        description:
          "Use this recipe as part of a know-your-business (KYB) workflow in the US to gather key ...",
        url: "/app/recipe/37/business-registration-and-ubo-for-us-kyb",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
      {
        title: "Business Registration and Linked Company Details for Global KYB",
        description: "Use this recipe as part of a know-your-business ...",
        url: "/app/recipe/65/business-registration-and-linked-company-details-for-global-kyb",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
      {
        title: "Business Customer Onboarding",
        description:
          "Use this recipe to make an assessment about the risk of onboarding a new business customer ...",
        url: "/app/recipe/54/business-customer-onboarding",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
      {
        title: "Email Address and Phone Number Fraud Risk Signals",
        description:
          "Use this recipe as part of a Know-Your-Customer (KYC) process to identify email addresses and ...",
        url: "/app/recipe/11/email-address-and-phone-number-fraud-risk-signals",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
      {
        title: "Person Homeowner Status for Prefill and Marketing",
        description:
          "Use this recipe to determine whether an individual rents or owns a specific property.",
        url: "/app/recipe/13/person-homeowner-status-for-prefill-and-marketing",
        type: "BUSINESS",
        ctaText: "Access Recipe",
      },
    ],
    insurance: [
      {
        title: "Property Prefill",
        description:
          "Use this recipe to prefill US property information for new residential or commercial property ...",
        url: "/app/recipe/21/property-prefill",
        type: "API",
        ctaText: "Access Recipe",
      },
      {
        title: "Business Prefill",
        description:
          "Use this recipe as part of a know-your-business (KYB) workflow in the US to gather key ...",
        url: "/app/recipe/32/business-prefill",
        type: "API",
        ctaText: "Access Recipe",
      },
      {
        title: "Auto Prefill From Person Identifier",
        description: "Use this recipe to prefill US vehicle information ...",
        url: "/app/recipe/28/auto-prefill-from-person-identifier",
        type: "API",
        ctaText: "Access Recipe",
      },
      {
        title: "Auto Prefill From Vehicle Identifier",
        description:
          "Use this recipe to prefill US vehicle information associated with a VIN number for auto ...",
        url: "/app/recipe/28/auto-prefill-from-person-identifier",
        type: "API",
        ctaText: "Access Recipe",
      },
      {
        title: "Business and Property Prefill",
        description:
          "Use this recipe to prefill information for US business lines or commercial property insurance ...",
        url: "/app/recipe/11/email-address-and-phone-number-fraud-risk-signals",
        type: "API",
        ctaText: "Access Recipe",
      },
      {
        title: "Automotive and Property Insurance Churn Indicators",
        description:
          "You can use this recipe to identify any indicators of churn risk in your automotive and property ...",
        url: "/app/recipe/51/automotive-and-property-insurance-churn-indicators",
        type: "API",
        ctaText: "Access Recipe",
      },
    ],
  },
  dataProviders: {
    financialServices: [
      {
        img: OpenCorporates,
        name: "Opencorporates",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=OpenCorporates`,
      },
      {
        img: Experian,
        name: "Experian",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Experian`,
      },
      {
        img: Equifax,
        name: "Equifax",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Equifax`,
      },
      {
        img: Sayari,
        name: "Sayari",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Sayari%20Labs`,
      },
      {
        img: Seon,
        name: "Seon",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Seon`,
      },
      {
        img: Ekata,
        name: "Ekata",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Ekata`,
      },
      {
        img: Nomino,
        name: "Nomino",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Nomino%20Data`,
      },
      {
        img: Acxiom,
        name: "Acxiom",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Acxiom`,
      },
    ],
    insurance: [
      {
        img: Attom,
        name: "Attom",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Attom`,
      },
      {
        img: HazardHub,
        name: "HazardHub",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=HazardHub`,
      },
      {
        img: Equifax,
        name: "Equifax",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Equifax`,
      },
      {
        img: Experian,
        name: "Experian",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Experian`,
      },
      {
        img: Acxiom,
        name: "Acxiom",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Acxiom`,
      },
      {
        img: DataAxle,
        name: "Data Axle",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Data%20Axle`,
      },
      {
        img: Infutor,
        name: "Infutor",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Infutor`,
      },
      {
        img: PeopleDataLabs,
        name: "People Data Labs",
        url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=People%20Data%20Labs`,
      },
    ],
  },
};

export default data;
